<template>
	<div >
		<section v-if="LocalKonum == 0 && !Hazir" class="home-two-slide d-flex align-items-center" style="justify-content:center">
			<div class="row ">
			<span  class="loader"></span>
			</div>
		</section>
		<section :class="{'topcategory-sec':LocalKonum == 0,'topcategory-sec sec2':LocalKonum==1}" v-if="Linkler.length > 0">
			<div class="container">
				<div class="header-two-title text-center" data-aos="fade-up">
					<p class="tagline" style="margin-bottom: -1rem;" :style="Text1StyleObject">Links</p>
					<!-- <h2>Top Category</h2> -->
					<div class="header-two-text">
						<!-- <p class="mb-0">Lorem ipsum dolor sit amet</p> -->
					</div>

				</div>
				<div class="top-category-group">
					
					<div class="row" style="justify-content: center;">
						<span v-if="!Hazir" class="loader"></span>
						<template v-if="Hazir && Linkler.length > 0">
							<div v-for="(item, index) in Linkler" :key="index" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-flex" data-aos="fade-down"
							v-on:click="linkGit(item.Link)" >
								<div class="categories-item flex-fill" :style="CardStyleObject">
									<div style="height: 100px;">

										<div class="categories-icon" style="text-align: center;">
											<img v-show="item.GorselAdi !='slp.png'" :src="`https://storage.googleapis.com/schoollms/img/links/${item.GorselAdi}`" class="img-fluid" style="height: 100px;">
											<img v-show="item.GorselAdi =='slp.png'" :src="`https://storage.googleapis.com/schoollms/img/links/${item.GorselAdi.split('.')[0]}${getSinifSeviye}.${item.GorselAdi.split('.')[1]}`" 
											class="img-fluid" style="height: 140px; margin-top:-15px">
										</div>
									</div>
									<div class="categories-content" :style="CardStyleObject">
										<h3 style="text-align: center; font-size: 16px!important;" :style="CardStyleObject">{{item.LinkBaslik}}</h3>
										<p style="margin-top:15px; font-size:14px; text-align: center">{{item.LinkAciklama}}</p>
									</div>
								</div>
							</div>							
						</template>
					</div>
				</div>
			</div>
		</section>
	</div>
	
</template>

<script>
import {mapGetters} from "vuex";
import LmsService from '@/services/lms.service';

export default {
	// eslint-disable-next-line vue/multi-word-component-names
	name: "links",
	props:['Konum'],
	data() {
		return {
			Hazir : false,
			Linkler: [],
			LocalKonum: this.Konum??0,		
		};
	},
	beforeMount() {
		const Izin = this.getRol =='teacher' ? this.getOkulAyarlar.OgretmenMenu2 : this.getOkulAyarlar.OgrenciMenu2
		if(Izin == 0 && this.Konum == 0){
			this.$router.push( { path : "/home" } )
			return
		}
		this.IlkYukleme();
	},

	computed:{
		...mapGetters(['getKullaniciDetaylari','getOkulAyarlar','getSinifSeviye','getKampusTipi','getKampusAdi','getKampusId','getOkulId','getSinifSeviye',
		'getOkulAdi','getRol','getOgretmenSinifSeviyeleri','getOgretmenSinifSubeIdleri','getSinifId','Button1StyleObject','CardStyleObject','Text1StyleObject']),
	},
	methods: {
		
        async IlkYukleme(){

            if (this.getKullaniciDetaylari) {

				await this.linkListesi()
        	}


		},

		async linkListesi(){
			try {
				let SinifSubeIdler, SinifSeviyeler 
				if (this.getRol == 'teacher'){
					if(this.getOgretmenSinifSubeIdleri.length > 0){
						SinifSubeIdler = this.getOgretmenSinifSubeIdleri.map(value => ({ SinifId: value })); // anahtar adı olmayan listeye anahtar atama
					}

					if(this.getOgretmenSinifSeviyeleri.length > 0){
						SinifSeviyeler = this.getOgretmenSinifSeviyeleri.map(value => ({ SinifSeviye: value })); // anahtar adı olmayan listeye anahtar atama
					}

				} else{
					SinifSubeIdler = [{SinifId: this.getSinifId}]
					SinifSeviyeler = [{SinifSeviye: this.getSinifSeviye}]
				}

				const data = {
					OkulId: this.getOkulId,
					KampusId: this.getKampusId,
					SinifSeviye: SinifSeviyeler,
					SinifId: SinifSubeIdler,
					Rol: this.getRol =='teacher' ? 1 : 0
				}	

				this.$store.commit('setLoading', true)
				const resData = await LmsService.OkulLinkleriGetir(data)
				this.Linkler = resData.filter(x=> x.Konum == this.LocalKonum )
                this.$store.commit('setLoading', false)
				this.Hazir = true
			} catch (error) {
				this.Hazir = true
                this.$store.commit('setLoading', false)
				this.$toast.open({
					message: "Öğrenim Araçları listesi alınamadı!",
					type: "error",
					duration: 3000,
					dismissible: true,
					position : 'top'
				})
				return
			}
		},

		linkGit(url){
			window.open(url, '_blank');
    	},

		activated() {
			

		},
		created () {
		}
	}
}
</script>

<style scoped>

</style>
